import { render, staticRenderFns } from "./AppointmentPaymentInfo.vue?vue&type=template&id=2e73f732"
import script from "./AppointmentPaymentInfo.vue?vue&type=script&lang=js"
export * from "./AppointmentPaymentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports